module.exports = __webpack_public_path__ + "static/media/image_37.61143fca.png";